import { baseUrl } from "../common/config";
import { http } from "../common/helpers";
import type { ParticipantBffLearningApi } from "../models/api";
import type { ApiResponse } from "../models/api/api-response";
import type { CourseActiveApi, CourseStatusApi } from "../models/api/course";
import type { FocusApi, ParticipantFocusApi } from "../models/api/focus";
import type { HelpApi } from "../models/api/help";
import type {
  LearningPathCourseApi,
  LearningPathProgressApi,
} from "../models/api/learning-path";
import type { ModuleLessonsApi } from "../models/api/module";
import type { ScoreCurrentApi } from "../models/api/score";

export const getProfileService = (id) => {
  return http.get(`${baseUrl}/api/participant?participantProfileId=${id}`);
};

export const getCurrentLearningPathId = async () => {
  const { data } = await http.get<ApiResponse<number>>(
    `${baseUrl}/api/assessments/learningpath/participant-current-learning-path`
  );
  return data.data;
};

export const setCurrentLearningPathId = async ({
  learningPathId,
}: {
  learningPathId: number;
}) => {
  const { data } = await http.patch<ApiResponse<boolean>>(
    `${baseUrl}/api/assessments/learningpath/participant-current-learning-path`,
    { learningPathId }
  );
  return data.data;
};

export const getLearningPath = async (id: number) => {
  const { data } = await http.get<ApiResponse<LearningPathCourseApi>>(
    `${baseUrl}/api/assessments/learningpath/${id}`
  );
  return data.data;
};

export const getCourseActive = async () => {
  const { data } = await http.get<ApiResponse<CourseActiveApi>>(
    `${baseUrl}/api/assessments/course/active`
  );
  return data.data;
};

export const getCourseProgressById = async (id: number) => {
  const { data } = await http.get<ApiResponse<CourseStatusApi>>(
    `${baseUrl}/api/assessments/learningpath/course/${id || ""}`
  );
  return data.data;
};

export const getModulesByCourseId = async (courseId: number) => {
  const { data } = await http.get<ApiResponse<ModuleLessonsApi[]>>(
    `${baseUrl}/api/assessments/learningpath/modules/course/${courseId}`
  );
  return data.data;
};

export const getParticipantLearningPath = async () => {
  const { data } = await http.get<ApiResponse<ParticipantBffLearningApi>>(
    `${baseUrl}/api/assessments/participant-bff/learning`
  );
  return data.data;
};

export const getParticipantActiveDays = async (endDate: Date) => {
  const { data } = await http.get<ApiResponse<Date[]>>(
    `${baseUrl}/api/assessments/participant-lesson/active-dates?endDateUTC=${endDate.toISOString()}`
  );
  return data.data;
};

export const getScore = async () => {
  const { data } = await http.get<ApiResponse<ScoreCurrentApi>>(
    `${baseUrl}/api/assessments/score/current`
  );
  return data.data;
};

export const getParticipantFocus = async (profileId: string) => {
  const { data } = await http.get<ApiResponse<ParticipantFocusApi>>(
    `${baseUrl}/api/assessments/focus/participant-focus/${profileId}`
  );
  return data.data;
};

export const getAllFocus = async () => {
  const { data } = await http.get<ApiResponse<FocusApi[]>>(
    `${baseUrl}/api/assessments/focus/all`
  );
  return data.data;
};

export const getPolicies = async () => {
  const { data } = await http.get<ApiResponse<HelpApi>>(
    `${baseUrl}/api/policies`
  );
  return data.data;
};

export const getLearningPathProgress = async () => {
  const { data } = await http.get<ApiResponse<LearningPathProgressApi>>(
    `${baseUrl}/api/v2/participant/learning-path/progress`
  );
  return data.data;
};
